import React from "react";

export function CategorySubProd(props:any) {
    var key = props.catKey;
    var catObj = props.catData[key];

    return (
        <>
            <div className="option--label" style={{marginRight:'10px', fontSize: '14px'}}>
                <span>
                    <input type="checkbox" style={{cursor:"pointer"}} onClick={props.onChecked} data-cat={catObj.slug} data-cat-term={props.parentKey} /> {catObj.label}
                </span>
                { catObj.total > 0 ?
                    <span className='item--counter'>{catObj.total}</span>
                    : <span>(0)</span>
                }
            </div>
        </>
    )
}

export function CategoryProp(props:any) {
    var key = props.catKey;
    var catObj = props.catData[key];
    var parentKey = catObj.name;

    return (
        <>
            {Object.keys(catObj.data).length > 0 ?
                <>
                    <li className="option--row-cat option-cat">
                        <div className='option-sub-cat' style={{padding: '0px 0px 0px 10px'}}>
                            <div className="option--label" style={{fontSize: '14px', color:'#111'}}>
                                {/* <span>
                                   <input type="checkbox" onClick={props.onChecked} data-cat={catObj.slug}/>
                                </span> */}
                                 <span>{catObj.label}</span>
                                {/* { catObj.total > 0 ?
                                   <span className='item--counter'>{catObj.total}</span>
                                   : <span className='item--counter'>0</span>
                                } */}
                                </div>
                            </div>
                        </li>
                   
                    <li className="option--row-cat option-cat">
                        <div className='option-sub-cat'>
                            <div className='option-sub-sub-cat'>
                                {Object.keys(catObj.data).map((key:string, index:number) => {
                                    return <CategorySubProd key={index.toString()} onChecked={props.onChecked} parentKey={parentKey} catKey={key} catData={catObj.data}/>
                                })}
                            </div>
                        </div>
                    </li>
                </>
                : null
            }
        </>
    )
}
